import React, { useState,useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { ChangeMobileFormat, GetPaymentStatus,PassedMonthsCode, addThousandPoint,GetPaymentDate,GetPaymentClassStatus,remainDays,isNull } from "../../components/common/Common";
import "../../css/style.css";

//결제내역
const PaymentHistory = () => {
  const { ch_idx,ph_idx } = useParams();
  const navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varPaymentInfo,setPaymentInfo] = useState({});
  const [varPaymentList,setPaymentList] = useState([]);

  //결제내역호출
  const GetPaymentInformation = async() => {
    const sendData = {ch_idx:ch_idx,ph_idx:ph_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_payment_history`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //결제 내역
        setPaymentList(datas.historys);
        //선택한 결제 정보
        setPaymentInfo(datas.payments[0]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetPaymentInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //결제취소
  const onCancelPaymentHandler = async(e,ph_idx) => {
    let workData = {...varPaymentInfo}; //h_idx === 0 인 경우
    if(ph_idx > 0) workData = varPaymentList.find(el=>el.ph_idx===ph_idx);

    //수업진행유무 점검 
    if(workData.ycount > 0) {
      alert('이미 수업이 진행되어 결제를 취소할 수 없습니다. 관리자에게 문의해주세요.'); return false;
    }

    if(!window.confirm('결제를 취소하시겠습니까?')) return false;

    //원생의 학기내 등록한 수업 총수
    let smc_idx = 0;
    let smc_studys = 0;
    let smc_store = 0;
    if(!isNull(workData.smc_idx)) smc_idx = workData.smc_idx;
    if(!isNull(workData.smc_studys)) smc_studys = workData.smc_studys - workData.cl_studys;
    if(!isNull(workData.smc_store)) smc_store = workData.smc_store - workData.cl_studys;

    let apiStrinhg = "branch_cancel_payment_gateway";
    //가맹점에서 결제한 경우
    if(workData.ph_who === 1) apiStrinhg = "branch_cancel_payment";

    const sendData = {ph_idx:workData.ph_idx,cl_idx:workData.ph_cl_idx,ch_idx:workData.ph_ch_idx,
            branch_member_id:workData.bh_member_id,branch_merchant_id:workData.bh_merchant_id,bill_id:workData.ivc_id,
            price:workData.ph_price,smc_idx:smc_idx,smc_store:smc_store,smc_studys:smc_studys};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/${apiStrinhg}`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate(`/Branch/PaymentCancel/${workData.ph_idx}`);
      } else {
        alert(datas.message);
      }
    });
  }

  //상태변경
  const onChangePaymentHandler = async(e,ph_idx,istatus) => {
    const prompt = (istatus===4)?'환불요청을 하시겠습니까?':'환불을 완료하셨습니까?';
    if(!window.confirm(prompt)) return false;

    let workData = {...varPaymentInfo}; //h_idx === 0 인 경우
    if(ph_idx > 0) workData = varPaymentList.find(el=>el.ph_idx===ph_idx);

    const cl_idx = workData.ph_cl_idx;
    const ch_idx = workData.ph_ch_idx

    const sendData = {ph_idx:workData.ph_idx,ph_status:istatus,cl_idx:cl_idx,ch_idx:ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_payment_status`,sendData).then((res) => {
    const datas = res.data;
    console.log(datas);
    if(datas.retvalue === 1) {
      GetPaymentInformation();
    } else {
      alert(datas.message);
    }
    });
  }
  
  //결제완료
  const onPaidPaymentHandler = async(e,payments) => {
    if(!window.confirm('결제가 완료되었습니까?')) return false;
    let sm_idx = 0;
    if(!isNull(payments.sm_idx)) sm_idx = payments.sm_idx;
    let smc_idx = 0;
    if(!isNull(payments.smc_idx)) smc_idx = payments.smc_idx;

    const sendData = {ph_idx:payments.ph_idx,cl_idx:payments.ph_cl_idx,ch_idx:payments.ph_ch_idx,
      sm_idx:sm_idx,smc_idx:smc_idx,cl_studys:payments.cl_studys,ph_status:payments.ph_status};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_paid_payment`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        GetPaymentInformation();
      } else {
        alert(datas.message);
      }
    });
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'결제 내역'}/>
      <div className="vh-content-body">
        <div className="payment-view-wrap">
          <div className="center-wrap">
            <div className="view-list">
              <div className="view-con">
                <div className="date-line">
                  <div className="date">{GetPaymentDate(varPaymentInfo)}</div>
                  <p className="price">₩ {addThousandPoint(varPaymentInfo.ph_price)} 원</p>
                </div>
                <div className="info-line">{varPaymentInfo.mem_name} {ChangeMobileFormat(varPaymentInfo.mem_mobile)} <span> 👼🏻[{varPaymentInfo.ch_name}({PassedMonthsCode(varPaymentInfo.ch_birthday)})]</span></div>
                <div className="flex">
                  <p>결제 유형</p>
                  {/* <div>{varPaymentInfo.ph_method===1?"카드":"현금"}</div> */}
                  <div>카드</div>
                </div>
                <div className="flex">
                  <p>결제 학기</p>
                  <div>{varPaymentInfo.sm_name}</div>
                </div>
                <div className="flex">
                  <p>결제 클래스</p>
                  <div>{varPaymentInfo.cl_name}</div>
                </div>
                <div className="flex">
                  <p>청구서 ID</p>
                  <div>{varPaymentInfo.ivc_id}</div>
                </div>
                <div className="flex">
                  <p>결제 상태</p>
                  <div className={GetPaymentClassStatus(varPaymentInfo.ph_status)}>
                    {GetPaymentStatus(varPaymentInfo.ph_status)}
                    {varPaymentInfo.ph_status===2 && remainDays(varPaymentInfo.ph_pdate) > -7 ?
                      <>&nbsp;|&nbsp;<span className="pay-state-cancel" onClick={e=>onCancelPaymentHandler(e,0)}>결제취소</span></>
                    :(varPaymentInfo.ph_status===2 || varPaymentInfo.ph_status===3) && varPaymentInfo.rem_studys > 0?
                      <>&nbsp;|&nbsp;<span className="pay-state-cancel" onClick={e=>onChangePaymentHandler(e,0,4)}>환불요청</span></>
                    :varPaymentInfo.ph_status===4 ?
                      <>&nbsp;|&nbsp;<span className="pay-state-cancel" onClick={e=>onChangePaymentHandler(e,0,5)}>환불완료</span></>
                    :varPaymentInfo.ph_status===1?
                      <>&nbsp;|&nbsp;<span className="pay-state01" onClick={e=>onPaidPaymentHandler(e,varPaymentInfo)}>결제완료</span></>
                    :null
                    }
                  </div>
                </div>									
              </div>
              <div className="top-line"><p>최근 1년 결제 내역</p></div>
              {varPaymentList.length===0?
                <div className="con-box">
                  <div className="txt-box">추가적인 결제내역은 없습니다.</div>
                </div>
              :
              varPaymentList.map((payments,i)=>(
                <div key={'payments_'+i} className="con-box">
                  <div className="txt-box">
                    <div className="date-line">
                      <div className="date">{GetPaymentDate(payments)}</div>
                      <p className="price">₩ {addThousandPoint(payments.ph_price)} 원</p>
                    </div>
                    <div className="info-line">{payments.mem_name} {ChangeMobileFormat(payments.mem_mobile)} <span> 👼🏻[{payments.ch_name}({PassedMonthsCode(payments.ch_birthday)})]</span></div>
                    <div className="flex">
                      <p>결제 유형</p>
                      {/* <div>{payments.ph_method===1?"카드":"현금"}</div> */}
                      <div>카드</div>
                    </div>
                    <div className="flex">
                      <p>결제 학기</p>
                      <div>{payments.sm_name}</div>
                    </div>
                    <div className="flex">
                      <p>결제 클래스</p>
                      <div>{payments.cl_name}</div>
                    </div>
                    <div className="flex">
                      <p>청구서 ID</p>
                      <div>{payments.ivc_id}</div>
                    </div>
                    <div className="flex">
                      <p>결제 상태</p>
                      <div className={GetPaymentClassStatus(payments.ph_status)}>
                        {GetPaymentStatus(payments.ph_status)}
                        {payments.ph_status===2 && remainDays(payments.ph_pdate) > -7 ?
                          <>&nbsp;|&nbsp;<span className="pay-state-cancel" onClick={e=>onCancelPaymentHandler(e,payments.ph_idx)}>결제취소</span></>
                        :(payments.ph_status===2 || payments.ph_status===3) && payments.rem_studys > 0?
                          <>&nbsp;|&nbsp;<span className="pay-state-cancel" onClick={e=>onChangePaymentHandler(e,payments.ph_idx,4)}>환불요청</span></>
                        :payments.ph_status===4 ?
                          <>&nbsp;|&nbsp;<span className="pay-state-cancel" onClick={e=>onChangePaymentHandler(e,payments.ph_idx,5)}>환불완료</span></>
                        :payments.ph_status===1?
                          <>&nbsp;|&nbsp;<span className="pay-state01" onClick={e=>onPaidPaymentHandler(e,payments)}>결제완료</span></>
                        :null
                        }
                      </div>
                    </div>	
                  </div>								
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default PaymentHistory;